import React from "react";
import { Button } from "antd";

export const RefundButton = (props) => {
    const { onClick, children, ...restProps } = props;

    return (
        <Button onClick={onClick} {...restProps}>
            {children || "Refund"}
        </Button>
    );
};

